import {Component, forwardRef, OnInit, ViewChild} from "@angular/core";
import {SelectComponent, SelectItem} from "ng2-select-compat";
import {TranslateService} from '@ngx-translate/core';
import {DetailService} from "../../../../../services/details/detail.service";
import {ReloadComponent} from "../../reload/reload.component";
import {Field} from "../../field";
import {map} from "rxjs/operators";
import {ContentsHelper} from "../../../../../helpers/contents.helper";

@Component({
	selector: "tig-assignment-select-multiple", template: `
	<div
		class="dynamic-field form-group"
        [class.has-error]="isInvalid()">
		<ng-template #tooltipTemplate><div [innerHtml]="getHint()|translate"></div></ng-template>
		<label class="col-lg-3 control-label" [ngClass]="{'tgi-required': isRequired()}">{{getLabelName()|translate}}
			<i *ngIf="getHint()" class="fa fa-info-circle"
				tooltip="{{getHint()|translate}}"
				placement="top"
				triggers="click"
				containerClass="tig-tooltip"
				delay="50"></i>
	        <span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
		<div class="col-lg-8">
			<ng-select
				[items]="ARR_options"
				[multiple]="(OBJ_field_config.multiple != null)?OBJ_field_config.multiple:true"
				[disabled]="OBJ_field_config?.readonly"
				(selected)="selected($event)"
				(removed)="removed($event)"
				(data)="refresh($event)"
				[placeholder]="'please_select'|translate"
				[allowClear]="true"
			></ng-select>
			 <span class="help-block m-b-none" *ngIf="isInvalid()">
                    {{'oError.sRequired'|translate}}
                </span>
		</div>
	</div>
	`, // get all components that extend relaodcomponent as viewChildren - see https://github.com/angular/angular/issues/8580
	providers: [{provide: ReloadComponent, useExisting: forwardRef(() => AssignmentSelectMultipleComponent)}, {
		provide: Field,
		useExisting: forwardRef(() => AssignmentSelectMultipleComponent)
	}]
})
export class AssignmentSelectMultipleComponent extends ReloadComponent implements OnInit {


	/**
	 * Attributes
	 */
	/**
	 * static muss true sein, damit aenderung von textfield auf name greift - in AfterViewInit ist es bereits zu spaet
	 * vgl. hierzu: https://angular.io/guide/static-query-migration#should-i-use-static-true
	 */
	@ViewChild(SelectComponent, {static: true}) OBJ_select_component: SelectComponent;
	ARR_options = [];   // all options
	ARR_selected = [];  // selected option


	/**
	 * Function > constructor
	 * @param OBJ_translate_service
	 * @param OBJ_detail_service
	 */
	constructor(private OBJ_translate_service: TranslateService, protected OBJ_detail_service: DetailService) {
		super(OBJ_detail_service);
	} // end constructor


	/**
	 * Function > ngOnInit
	 * @return {any}
	 */
	ngOnInit(): void {
		// change text-field from 'text' (default) to 'title'
		this.OBJ_select_component.textField = "title";
		this.getDependentFields(this.OBJ_translate_service);

		// this item has external options
		if (DetailService.externalOptions(this.OBJ_field_config)) {
			// tell the item how to reload and handle the options - the form itsself will later subscribe and check if all went well
			this.OBJ_observable_external_data = this.createObservable();
		} // end if
	} // end function ngOnInit


	/**
	 * Function > isInvalid
	 * @return {boolean}
	 */
	isInvalid(): boolean {
		if (this.isRequired()) {
			return this.OBJ_data.ids.length === 0;
		} // end if
		return false;
	} // end function isInvalid


	/**
	 * Function > selected
	 * @param {object} OBJ_item
	 */
	public selected(OBJ_item: SelectItem): void {
		this.OBJ_data.ids.push(OBJ_item.id);
	} // end function selected


	/**
	 * Function > removed
	 * @param {object} OBJ_item
	 */
	public removed(OBJ_item: SelectItem): void {
		this.OBJ_data.ids = this.OBJ_data.ids.filter(STR_id => STR_id !== OBJ_item.id);
	} // end function removed


	/**
	 * Function > refresh
	 * @param {array} ARR_items
	 */
	public refresh(ARR_items: SelectItem): void {
	} // end function refresh


	/**
	 * Function > createObservable
	 */
	createObservable() {
		return this.OBJ_detail_service.getHelper(this.OBJ_field_config._links.options.href, null, 'SelectMultipleComponent')
			.pipe(map((OBJ_contents_helper: ContentsHelper) => {
				this.ARR_options = OBJ_contents_helper.getListingData();
				let OBJ_item;
				for (let STR_id of this.OBJ_data.ids) {
					this.ARR_selected.push(this.ARR_options.find(OBJ_item =>  OBJ_item.id == STR_id));
				} // end for
				this.OBJ_select_component.active = this.ARR_selected;
			}));
	} // end function createObservable


} // end class AssignmentSelectMultipleComponent
